// extracted by mini-css-extract-plugin
export default {"inputWrapper":"Input_inputWrapper__N6MNy","pinInput":"Input_pinInput__pIyV5","sendBtn":"Input_sendBtn__aT0g+"};